import { selectorsCreators } from 'store/common'

import { REDUCER_NAME_ME } from 'utils/constants/store/reducersNames'

export const getStatic = selectorsCreators.makeGetStaticsEntity({
  staticEntityKey: REDUCER_NAME_ME,
})
